module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"onLineBriefing":{"title":"自家倉庫の登録説明会（オンライン）","description":"登録を検討中の自家倉庫オーナー様を対象に、詳しい説明会を開催しています","form":"参加お申込みフォーム"}}}')
  delete Component.options._Ctor
}
